export const dataFormat = (value: string | null): string =>
  value && value.trim() ? value : '-';
